import { render, staticRenderFns } from "./FreeFormAttributeRow.vue?vue&type=template&id=64daa6f4&scoped=true"
import script from "./FreeFormAttributeRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./FreeFormAttributeRow.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FreeFormAttributeRow.vue?vue&type=style&index=0&id=64daa6f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64daa6f4",
  null
  
)

export default component.exports